import { render, staticRenderFns } from "./batchAddSupplier.vue?vue&type=template&id=115bdcfa&scoped=true"
import script from "./batchAddSupplier.vue?vue&type=script&lang=js"
export * from "./batchAddSupplier.vue?vue&type=script&lang=js"
import style0 from "./batchAddSupplier.vue?vue&type=style&index=0&id=115bdcfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115bdcfa",
  null
  
)

export default component.exports